import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PltTreeSearchComponent } from './plttreesearch.component';
import { DocTreeSearchComponent } from './doctreesearch.component';
import { DocSearchComponent } from './docsearch.component';
import { CustomTreeSearchComponent } from './customtreesearch.component';
import { LinkComponent } from './link.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [PltTreeSearchComponent, DocTreeSearchComponent, DocSearchComponent, CustomTreeSearchComponent, LinkComponent],
  imports: [CommonModule, TranslateModule, MatCardModule, MatIconModule],
})
export class PermaModule {}
